import { useEffect, useState } from "react";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import ImageViewer from "./ImageViewer";
import { Button } from "./ui/button";

const getFirebaseUrl = async (path) => {
  const storage = getStorage();
  return getDownloadURL(ref(storage, path));
};

function Peak({ refId, allImages }) {
  const [updatedImages, setUpdatedImages] = useState([]);
  const [loadingMap, setLoadingMap] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!allImages || !allImages.length) {
      setUpdatedImages([]);
      return;
    }

    const load = async () => {
      const res = await Promise.all(
        allImages.map(async (img, idx) => {
          setLoadingMap((p) => ({ ...p, [idx]: true }));
          const url = await getFirebaseUrl(img.url);
          setLoadingMap((p) => ({ ...p, [idx]: false }));
          return { ...img, url };
        })
      );
      setUpdatedImages(res);
    };

    load();
  }, [allImages]);

  return (
    <div
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <Button className="px-6 rounded-full">
        Preview
      </Button>
      
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
          <div
            className="bg-white rounded-lg w-[90vw] max-w-4xl p-4 shadow-lg pointer-events-auto"
          >
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-md font-bold">Reference ID: {refId}</h2>
              <button 
                onClick={() => setOpen(false)}
                className="text-lg font-bold"
              >
                ✕
              </button>
            </div>
      
            {!updatedImages.length && (
              <p className="text-sm text-muted">No product images</p>
            )}
    
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-h-[70vh] overflow-auto">
              {updatedImages.map((img, idx) => (
                <div
                  key={idx}
                  className="border rounded-md p-2 flex flex-col items-center"
                >
                  {loadingMap[idx] ? (
                    <div className="h-32 w-full flex items-center justify-center">
                      <div className="h-8 w-8 animate-spin rounded-full border-t-2 border-green" />
                    </div>
                  ) : (
                    <ImageViewer src={img.url} alt={img?.description} />
                  )}
    
                  {img?.description && (
                    <p className="mt-2 text-sm text-muted text-center">
                      {img.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Peak;
